// extracted by mini-css-extract-plugin
export default {"gear":"NotificationsCustomer_gear__TpQho","container":"NotificationsCustomer_container__YlCX+","border":"NotificationsCustomer_border__i7jpm"};